import { render, staticRenderFns } from "./Oct20th.vue?vue&type=template&id=46014f65&scoped=true&"
import script from "./Oct20th.vue?vue&type=script&lang=js&"
export * from "./Oct20th.vue?vue&type=script&lang=js&"
import style0 from "./Oct20th.vue?vue&type=style&index=0&id=46014f65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46014f65",
  null
  
)

export default component.exports